module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-window', {
    attrs: {
      "touchless": ""
    },
    model: {
      value: (_vm.window),
      callback: function($$v) {
        _vm.window = $$v
      },
      expression: "window"
    }
  }, [(_vm.loading) ? _c('v-progress-linear', {
    staticClass: "ma-0",
    attrs: {
      "indeterminate": "",
      "height": 2
    }
  }) : _vm._e(), _vm._v(" "), _c('v-window-item', [(_vm.saveRequest) ? _c('request-status', {
    attrs: {
      "request": _vm.saveRequest
    }
  }) : _vm._e(), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": "",
      "three-line": "",
      "dark": ""
    }
  }, [_c('appointment-list-item', {
    attrs: {
      "appointment": _vm.appointment,
      "with-color-coding": false,
      "with-status-chips": true,
      "with-action": false
    }
  })], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', [_c('v-list', {
    attrs: {
      "three-line": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "lazy": "",
      "width": "325"
    },
    model: {
      value: (_vm.viz.daymodal),
      callback: function($$v) {
        _vm.$set(_vm.viz, "daymodal", $$v)
      },
      expression: "viz.daymodal"
    }
  }, [_c('v-list-tile', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("event")])], 1), _vm._v(" "), _c('v-list-tile-content', [(!_vm.timeData.date) ? _c('v-list-tile-title', [_vm._v("Day")]) : _c('v-list-tile-title', [_c('v-btn', {
    staticClass: "ma-0 hidden-xs-only",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.dateDelta(-1)
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v("\n                  " + _vm._s(_vm.dateformat(_vm.timeData.date, 'ddd DD MMM')) + "\n                  "), _c('v-btn', {
    staticClass: "ma-0 hidden-xs-only",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.dateDelta(1)
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)], 1), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("click to change selected day")])], 1), _vm._v(" "), (_vm.appointment.day) ? _c('v-list-tile-avatar', [_c('v-icon', [_vm._v("check")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "full-width": "",
      "scrollable": "",
      "actions": "",
      "autosave": ""
    },
    on: {
      "input": function($event) {
        _vm.viz.daymodal = false
      }
    },
    model: {
      value: (_vm.timeData.date),
      callback: function($$v) {
        _vm.$set(_vm.timeData, "date", $$v)
      },
      expression: "timeData.date"
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("access_time")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    staticStyle: {
      "height": "32px"
    }
  }, [_c('v-dialog', {
    attrs: {
      "lazy": "",
      "width": "325"
    },
    model: {
      value: (_vm.viz.starttime),
      callback: function($$v) {
        _vm.$set(_vm.viz, "starttime", $$v)
      },
      expression: "viz.starttime"
    }
  }, [_c('v-chip', {
    attrs: {
      "slot": "activator",
      "small": ""
    },
    slot: "activator"
  }, [(!_vm.timeData.start) ? _c('span', [_vm._v("Start time")]) : _c('span', [_vm._v(_vm._s(_vm.timeData.start))])]), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-time-picker', {
    attrs: {
      "full-width": "",
      "scrollable": "",
      "format": "24hr",
      "autosave": ""
    },
    on: {
      "input": _vm.startTimeChanged
    },
    model: {
      value: (_vm.timeData.start),
      callback: function($$v) {
        _vm.$set(_vm.timeData, "start", $$v)
      },
      expression: "timeData.start"
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.viz.starttime = false
      }
    }
  }, [_vm._v("Done")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.viz.starttime = false;
        _vm.viz.endtime = true
      }
    }
  }, [_vm._v("Choose end time "), _c('v-icon', [_vm._v("arrow_forward")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("arrow_forward")]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "width": "325"
    },
    model: {
      value: (_vm.viz.endtime),
      callback: function($$v) {
        _vm.$set(_vm.viz, "endtime", $$v)
      },
      expression: "viz.endtime"
    }
  }, [_c('v-chip', {
    attrs: {
      "slot": "activator",
      "small": ""
    },
    slot: "activator"
  }, [(!_vm.timeData.end) ? _c('span', [_vm._v("End time")]) : _c('span', [_vm._v(_vm._s(_vm.timeData.end))])]), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-time-picker', {
    attrs: {
      "full-width": "",
      "min": _vm.timeData.start,
      "scrollable": "",
      "format": "24hr",
      "autosave": ""
    },
    on: {
      "input": _vm.endTimeChanged
    },
    model: {
      value: (_vm.timeData.end),
      callback: function($$v) {
        _vm.$set(_vm.timeData, "end", $$v)
      },
      expression: "timeData.end"
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.viz.endtime = false;
        _vm.viz.starttime = true
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_back")]), _vm._v("Change start time")], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.viz.endtime = false
      }
    }
  }, [_vm._v("Done")])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.timeData.start && _vm.timeData.end) ? _c('v-list-tile-sub-title', [_vm._v("\n                    " + _vm._s(_vm.timeData.difference) + " minutes\n                  ")]) : _c('v-list-tile-sub-title', [_vm._v("\n                    Choose a start and end time\n                  ")])], 1), _vm._v(" "), (_vm.timeData.start && _vm.timeData.end) ? _c('v-list-tile-avatar', [_c('v-icon', [_vm._v("check")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "single-line": "",
      "disabled": !_vm.messageTarget
    }
  }, [_c('v-list-tile-avatar', [(_vm.apptDetailReq.loading || _vm.clientReq.loading) ? _c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "amber",
      "width": "2"
    }
  }) : _c('v-checkbox', {
    attrs: {
      "disabled": !_vm.messageTarget
    },
    model: {
      value: (_vm.notifications),
      callback: function($$v) {
        _vm.notifications = $$v
      },
      expression: "notifications"
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                  Notify the customer of the change?\n                ")]), _vm._v(" "), (_vm.messageTarget) ? _c('v-list-tile-sub-title', [_c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "outline": "",
      "color": "primary"
    }
  }, [(_vm.message.type === 'Email') ? _c('v-icon', {
    attrs: {
      "small": "",
      "left": ""
    }
  }, [_vm._v("email")]) : _vm._e(), _vm._v(" "), (_vm.message.type === 'SMS') ? _c('v-icon', {
    attrs: {
      "small": "",
      "left": ""
    }
  }, [_vm._v("phone")]) : _vm._e(), _vm._v("\n                    " + _vm._s(_vm.messageTarget) + "\n                  ")], 1)], 1) : _c('v-list-tile-sub-title', [_vm._v("\n                  Notifications are send via " + _vm._s(_vm.message.type) + ", and " + _vm._s(_vm.client.first_name) + " has no\n                  "), (_vm.message.type === "Email") ? _c('span', [_vm._v("email address")]) : _vm._e(), _vm._v(" "), (_vm.message.type === "SMS") ? _c('span', [_vm._v("phone number")]) : _vm._e(), _vm._v(" "), _c('v-icon', {
    attrs: {
      "color": "amber"
    }
  }, [_vm._v("warning")])], 1), _vm._v(" "), (_vm.notifications === true) ? _c('v-list-tile-sub-title', [_vm._v("\n                  We'll send an " + _vm._s(_vm.message.type) + " to the client informing them that their appointment has been rescheduled\n                ")]) : _c('v-list-tile-sub-title', [_vm._v("\n                  No notifications will be sent\n                ")])], 1), _vm._v(" "), _c('v-list-tile-avatar', [(_vm.notifications) ? _c('v-icon', [_vm._v("notifications_on")]) : _c('v-icon', [_vm._v("notifications_off")])], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("Reschedule")]), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-sub-title', {
    staticClass: "overline"
  }, [_vm._v("From")]), _vm._v(" "), _c('v-list-tile-title', [_vm._v("\n                " + _vm._s(_vm.dateformat(_vm.appointment.start_time, 'ddd DD MMM \\at HH:mma')) + "\n              ")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-sub-title', {
    staticClass: "overline"
  }, [_vm._v("To")]), _vm._v(" "), _c('v-list-tile-title', [_c('v-icon', {
    staticClass: "mr-4",
    attrs: {
      "small": ""
    }
  }, [_vm._v("arrow_forward")]), _vm._v("\n                " + _vm._s(_vm.dateformat(_vm.formattedAppointment.new_start_time, 'ddd DD MMM \\at HH:mma')) + "\n              ")], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    class: _vm.mobileCardActionsClasses,
    style: (_vm.mobileCardActionsStyles)
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "text": ""
    },
    on: {
      "click": _vm.resetDateTime
    }
  }, [_vm._v("Reset")]), _vm._v(" "), (_vm.clientErrors && _vm.clientErrors.length > 0) ? _c('span', {
    staticClass: "orange--text subheading"
  }, [_c('v-icon', {
    staticClass: "ml-2 mr-2",
    attrs: {
      "color": "orange"
    }
  }, [_vm._v("warning")]), _vm._v("\n              " + _vm._s(_vm.clientErrors[0]) + "\n            ")], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.loading,
      "disabled": !_vm.isValid || !_vm.isNewTime,
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n              Reschedule")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "hidden-xs-only",
    attrs: {
      "sm6": ""
    }
  }, [(_vm.practitioner && _vm.timeData && _vm.timeData.date) ? _c('practitioner-day-view', {
    staticClass: "ma-2 elevation-10",
    attrs: {
      "with-title": "",
      "with-date-bar": "",
      "block-events": "",
      "with-week": "",
      "practitioner": _vm.practitioner,
      "date": _vm.timeData.date,
      "preview-event": _vm.previewEvent
    },
    on: {
      "slotSelected": _vm.setStartTime,
      "update:date": function($event) {
        return _vm.$set(_vm.timeData, "date", $event)
      }
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-window-item', [_c('v-layout', [_c('v-flex'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "lg3": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center ma-4"
  }, [_c('v-icon', {
    staticClass: "ma-4",
    attrs: {
      "size": "72",
      "color": "green"
    }
  }, [_vm._v("check_circle")]), _vm._v(" "), _c('blockquote', {
    staticClass: "blockquote"
  }, [_vm._v("\n            Appointment Rescheduled\n          ")]), _vm._v(" "), (_vm.batchId) ? _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("Notifications:")]), _vm._v(" "), _c('batch-id-list', {
    attrs: {
      "batch-id": _vm.batchId
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.updatedAppointment && _vm.updatedAppointment.id) ? _c('v-list', {
    staticClass: "my-0 py-0",
    attrs: {
      "three-line": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("Updated appointment:")]), _vm._v(" "), _c('appointment-list-item', {
    attrs: {
      "with-status-chips": "",
      "with-color-coding": false,
      "appointment": _vm.updatedAppointment,
      "with-ction": false,
      "with-tags": false
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.init();
        _vm.$emit("close")
      }
    }
  }, [_vm._v("Done")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex')], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-665afa50","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/appointment/edit/Reschedule.vue
// module id = 1451
// module chunks = 9